
import { defineComponent, ref, onMounted, reactive } from "vue";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import { MenuComponent } from "@/assets/ts/components";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import * as moment from "moment";
import SearchAndFilter from "@/views/still/search_and_filters.vue";
import { useI18n } from "vue-i18n";
import StockRefs from "./stockRefs.vue";

import XLSX from "xlsx";
import mAxiosApi from "@/api";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Liste des commandes en cours",
  components: {
    Datatable,
    SearchAndFilter,
    StockRefs,
  },
  setup() {
    //moment.default.locale("fr");
    const router = useRouter()
    const state = reactive({
      loaderEnabled: true,
      myList: [],
      drawer: ref(false),
      sourcePDF: "",
      mObj: {} as any,
      mFact: "",
      initialMyList: [],
      loadingDatatable: 0,
      search: "",
      refMask: 0,
      searchDefault: router.currentRoute.value.params.code ? router.currentRoute.value.params.code + "" : "",
      myListAvecSn: [],
    });
    const { t } = useI18n()
    const activeName = "first"

    const tableHeader = ref([
      {
        name: "",
        key: "liv_seq",
        sortable: false,
      },
      {
        name: "Equipement",
        key: "theReference",
        sortable: true,
      },
      {
        name: "N° PO",
        key: "toc_code",
        sortable: true,
      },
      {
        name: "Qté Dispo / Réappro",
        key: "qte",
        sortable: true,
      },
      {
        name: "Echéance stock",
        key: "date_liv",
        sortable: true,
      },
      {
        name: "Historique",
        key: "histo",
        sortable: true,
      },
    ]);

    const tableFilters = ref([
      // {
      //   name: "Sites",
      //   key: "site",
      //   label: "site",
      // },
      {
        name: "Réapprovisionnement",
        key: "status_reappro",
        label: "status_reappro",
      },
      {
        name: "Référence",
        key: "loc_reference",
        label: "loc_reference"
      },
      {
        name: "Commande",
        key: "cmdFiltre",
        label: "cmdFiltre",
      },
      {
        name: "Disponibilité",
        key: "status_qte",
        label: "status_qte",
        default : ["Disponible"],
      },
    ]);

    const ExcelFormat = ref({
      "Constructeur" : "soc_nom_societe",
      "Référence": "loc_reference",
      "Quantité": "qte",  
      "N° PO": "toc_code_po",
      "Disponible le": "date_liv",
      Site: "site",
    });

   const formatDate = (d) => {
      return moment.default(d).format("DD.MM.YYYY");
    };
    const formatDateAgo = (d) => {
      return moment.default(d, "YYYY-MM-DD").fromNow();
    };

    const formatMoney = (n) => {
      if (!n) n = 0;
      return n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    };

    const returnUrlOffre = (data) => {
      return `/stillboard/offres/${data}`;
    };

    const returnUrlCommande = (data) => {
      return `/commande/${data}/livraisons`;
    };

    const formatHoverDateD = (data) => {
      if (!data.date_old_ldc) {
        return `${t("La date de livraison n'a connue aucune variation depuis le")} ${formatDate(
          data.toc_date_creation
        )} `;
      }
      return `${formatDateAgo(
        data.fraicheur
      )}, ${t("la date de livraison est passée du")} ${formatDate(
        data.date_old_ldc
      )} ${t("au")} ${formatDate(data.date_ldc)}`;
    };

    const affDetail = async () => {
      state.drawer = true;
    };

    const checkEcheance = (date) => {
      date = new Date(date)
      return new Date >= date ? "text-danger" : "text-dark"
    }

    onMounted(async () => {
      MenuComponent.reinitialization();
      setCurrentPageBreadcrumbs("Outils de déploiement", []);

      let myList = await mAxiosApi.prototype.getAxios("/getstock").catch(() => {return false});
      let getstockProduct = await mAxiosApi.prototype.getAxios("/getstockProduct").catch(() => {return false});
      let getstockReappro = await mAxiosApi.prototype.getAxios("/getstockReappro").catch(() => {return false});
      let getstockEcheance = await mAxiosApi.prototype.getAxios("/getstockEcheance").catch(() => {return false});
      
      let myListServiceFinal = [] as any;
      state.refMask = 0;
      myList.records.forEach((el) => {

        el.theReference = el.loc_reference;
        if (el.liv_ref_secondaire) el.theReference = el.liv_ref_secondaire;
        

        el.qte_exped = 0;
        // el.qte_max = parseInt(el.qte) // + parseInt(el.reappro)
        // el.qte = parseInt(el.qte);      
        el.toc_code = JSON.parse(el.toc_code);
        el.toc_code_all = JSON.parse(el.toc_code_all);

        if(el.toc_code_all.filter(el => el.toc_x_invisible_stock== 1).length > 0 ) {
          el.visible = 0;
          state.refMask++;
        } else {
          el.visible = 1;
        }
        const oldEl = {...el};
        const arrayToc = [...el.toc_code];
        const arrayTocAll = [...el.toc_code_all];
       
        arrayToc.forEach((el2) => {
          el.toc_code = [el2];
          el.toc_code_all = arrayTocAll.filter(al => al.refCmd == el2.numcmd );

          // Récupération de la ligne produit détaillée pour enrichir l'item (lof_line_number, groupe, displayrow, opensub)
          let productRecord: any;
          if (!el.liv_ref_secondaire) {
            productRecord = getstockProduct.records.find(
              (aa) =>
                aa.toc_code == el2.numcmd &&
                aa.loc_reference?.toUpperCase() === el.loc_reference?.toUpperCase() &&
                !aa.liv_ref_secondaire
            );
          } else {
            productRecord = getstockProduct.records.find(
              (aa) =>
                aa.toc_code == el2.numcmd &&
                aa.loc_reference?.toUpperCase() === el.loc_reference?.toUpperCase() &&
                aa.liv_ref_secondaire?.toUpperCase() === el.liv_ref_secondaire?.toUpperCase()
            );
          }

          el.qte_max = (productRecord || { en_stock: 0 }).en_stock;

          // Injection des infos de hiérarchie de ligne si disponibles
          if (productRecord) {
            el.liv_seq = productRecord.liv_seq;
            el.lof_line_number = productRecord.lof_line_number;
            el.lof_knum_ligne_groupe = productRecord.lof_knum_ligne_groupe;
            el.displayrow = productRecord.displayrow;
            el.opensub = productRecord.opensub;
            // marcus
            el.toc_x_lngs_majeures = productRecord.toc_x_lngs_majeures;
          }

          if (el.toc_x_lngs_majeures == 1) {
            el.lof_line_number = '1.0';            
          }

          el.qte = parseInt(el.qte_max);    
          el.numcmd = el2.numcmd;

          el.reappro = 0;
          el.date_reappro = "";
          el.status_reappro = "Sans réapprovisionnement";
      
          if (el.qte > 0 || el.reappro > 0) {
            el.status_qte = 'Disponible';
          } else {
            el.status_qte = 'Indisponible';
          }
          if(el.toc_code_all.filter(el => el.toc_x_invisible_stock== 1).length > 0 ) {
            el.status_qte = "Référence masquée";
          }
          
          el.cmdFiltre = el.toc_code[0].code;

          el.list_ticketsjson = JSON.parse(el.list_tickets)
          el.list_ticketsjson = el.list_ticketsjson.filter(element => {
            const searchStr =  ","+element.toc_seq+",";
            return searchStr.indexOf(el.toc_code[0].toc_seq);
          })

          let baseTotal = 0
          el.list_ticketsjson.forEach(element => {
            if (element.toc_seq == el.toc_code[0].toc_seq) {
              baseTotal = baseTotal + element.total
            }
          });
          el.total_qte = baseTotal + el.qte

          const date_ech = getstockEcheance.records.filter(ee => {
           return ee.loc_reference == el.loc_reference && ee.toc_seq == el.toc_code[0].toc_seq
          })

          el.date_liv = date_ech.length > 0 ?  date_ech[0].date_echeance : "";

          myListServiceFinal.push({...el});
        })
      })

      getstockReappro.records.forEach((el) => {

        const DateLiv = getstockProduct.records.filter(aa => aa.toc_seq == el.toc_seq && aa.loc_reference == el.loc_reference && aa.liv_ref_secondaire == el.liv_ref_secondaire)[0].liv_date_liv;

        const arrayFi = myListServiceFinal.findIndex(aa => aa.loc_reference == el.loc_reference && aa.liv_ref_secondaire == el.liv_ref_secondaire && aa.toc_code[0].toc_seq == el.toc_seq);
        if (arrayFi > -1 ) {
          myListServiceFinal[arrayFi].reappro = el.total;
          if (myListServiceFinal[arrayFi].reappro > 0) {
            myListServiceFinal[arrayFi].status_qte = 'Disponible';
            myListServiceFinal[arrayFi].status_reappro = "Réapprovisionnement en cours";
            myListServiceFinal[arrayFi].date_reappro = DateLiv; //el.date_reappro;
            if (!myListServiceFinal[arrayFi].qte) myListServiceFinal[arrayFi].date_liv = "";
          }
        }else {
          myListServiceFinal.push(
            {
              'qte' : 0,
              'status_qte' : 'Disponible',
              'status_reappro' : 'Réapprovisionnement en cours',
              'date_reappro' : DateLiv, //el.date_reappro,
              'loc_reference' : el.loc_reference,
              'liv_ref_secondaire' : el.liv_ref_secondaire,
              'reappro' : el.total,
              'loc_designation' : el.loc_designation,
              'soc_nom_societe' : el.soc_nom_societe,
              'toc_code' : [{'toc_seq' : el.toc_seq,  'numcmd' : el.toc_code, 'code' : el.toc_num_commande_client, }],
              'list_ticketsjson' : {},
              'theReference' : el.liv_ref_secondaire ? el.liv_ref_secondaire : el.loc_reference,
            }          
          );
        }
      })

      myListServiceFinal = myListServiceFinal.sort((a, b) => {
        const codeA = a.toc_code && a.toc_code[0] ? a.toc_code[0].code || a.toc_code[0].numcmd || "" : "";
        const codeB = b.toc_code && b.toc_code[0] ? b.toc_code[0].code || b.toc_code[0].numcmd || "" : "";

        if (codeA === codeB) {
          const lnA = a.lof_line_number || "";
          const lnB = b.lof_line_number || "";
          if (lnA === lnB) return 0;
          return lnA > lnB ? 1 : -1;
        }

        return codeA > codeB ? 1 : -1;
      });

      let curMajeur = 0;
      myListServiceFinal.forEach((el: any) => {

        if ( el.lof_line_number && (el.lof_line_number.indexOf('.') ==  el.lof_line_number.lastIndexOf('.')) && (el.lof_line_number.indexOf('.0') > 0 ) ) {
          curMajeur = el.liv_seq;
          el.opensub = 0;
          el.displayrow = 1;
        } else if (el.lof_line_number && el.lof_line_number.length >0 && curMajeur>0 ) {
          el.lof_knum_ligne_groupe = curMajeur;
          el.displayrow = 2;
        } 
      });

      state.initialMyList = myListServiceFinal;
      state.myList = myListServiceFinal;
      state.loaderEnabled = false;

      let getstocksn = await mAxiosApi.prototype.getAxios("/getstocksn").catch(() => {return false});
      let listAvecSn = [];

      if (getstocksn && getstocksn.records) {
        listAvecSn = getstocksn.records.map((record) => {
          return {
            "Reference": record.loc_reference,
            "Désignation": record.loc_designation,
            "Quantité": record.liv_qte,
            "Code PO": record.toc_num_commande_client,
            "Serial Numbers": record.liv_all_sn,
          };
        });
      } else {
        console.error("Pas de données a afficher");
      }

      state.myListAvecSn = listAvecSn;
    });

    const isRefMajeur = (d) => {
      if (d.toc_x_lngs_majeures === 1) {
        return false;
      }

      const listTmp = state.myList.filter(
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (item: any) => item.lof_knum_ligne_groupe === d.liv_seq  
      );
      return listTmp.length > 0;
    }

    const isRefMajeurLN = (d) => {
      if (d.toc_x_lngs_majeures === 1) {
        return true;
      }

      if (d.lof_line_number) {
        return d.lof_line_number.indexOf('.0') > 0;
      } else {
        return true;
      }      
    }

    const openSubItem = (d: any) => {
      state.myList.forEach((el: any) => {
        if (el.liv_seq === d.liv_seq) {
          el.opensub = d.opensub === 0 ? 1 : 0;
        }
        if (el.lof_knum_ligne_groupe === d.liv_seq) {
          el.displayrow = d.opensub === 0 ? 1 : 2;
        }
      });
    };

    const openHisto = async (data) => {
      state.mObj = data;
      state.drawer = true;
    };

    const exportSN = () => {

      const dataToExport =  state.myListAvecSn;

      const wb = XLSX.utils.book_new();

      // Convertissez state.listeAvecSN en une feuille de calcul
      const ws = XLSX.utils.json_to_sheet(dataToExport);

      // Ajoutez la feuille au classeur
      XLSX.utils.book_append_sheet(wb, ws, "ListAvecSN");

      // Exportez le classeur
      XLSX.writeFile(wb, 'Stillnetwork_stock.xlsx');
    };

    return {
      tableHeader,
      state,
      formatDate,
      formatDateAgo,
      formatMoney,
      affDetail,
      formatHoverDateD,
      returnUrlOffre,
      returnUrlCommande,
      tableFilters,
      ExcelFormat,
      openHisto,
      checkEcheance,
      activeName,
      exportSN,
      isRefMajeur,
      isRefMajeurLN,
      openSubItem,
    };
  },
});
